import React from 'react';
import styles from './ContentGrid.module.css';

type ContentGridProps = {
  rows?: string;
  tabletRows?: string;
  mobileRows?: string;
  children: React.ReactNode;
};

const ContentGrid: React.FC<ContentGridProps> = ({ 
  rows = 'auto', 
  tabletRows, 
  mobileRows, 
  children 
}) => {
  // Create dynamic CSS that applies the responsive rows
  const dynamicCSS = `
    .${styles.grid} {
      grid-template-rows: ${rows};
    }
    ${tabletRows ? `
    @media (max-width: 1024px) {
      .${styles.grid} {
        grid-template-rows: ${tabletRows} !important;
      }
    }` : ''}
    ${mobileRows ? `
    @media (max-width: 620px) {
      .${styles.grid} {
        grid-template-rows: ${mobileRows} !important;
      }
    }` : ''}
  `;

  return (
    <>
      <style>{dynamicCSS}</style>
      <div className={styles.grid}>
        {children}
      </div>
    </>
  );
};

export default ContentGrid;